import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from './index';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

// --- Nav Header Tab Clicks ---

// https://dataportal.zillowgroup.net/event-registry/9107
export const emitAnalyticsNavOverviewClickEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9107',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'overview',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'change_analytics_tab',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9108
export const emitAnalyticsNavMarketDataClickEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9108',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'market_data',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'change_analytics_tab',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9109
export const emitAnalyticsNavRenterDataClickEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9109',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'renter_data',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'change_analytics_tab',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9110
export const emitAnalyticsNavAdSpendClickEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9110',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'ad_spend',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'change_analytics_tab',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9111
export const emitAnalyticsNavIndustryReportsClickEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9111',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'industry_reports',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'change_analytics_tab',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Analytics Filters ---

// https://dataportal.zillowgroup.net/event-registry/9112
export const emitAnalyticsFilterChoosePropertyEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9112',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_a_property',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'apply_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9113
export const emitAnalyticsFilterChooseAdPackageEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9113',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_ad_package_filter',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'apply_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9114
export const emitAnalyticsFilterChooseStateEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9114',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_state_filter',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'apply_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9115
export const emitAnalyticsFilterChooseMsaEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9115',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_msa_filter',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'apply_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9116
export const emitAnalyticsFilterChooseCityEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9116',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_city_filter',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'apply_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9117
export const emitAnalyticsFilterChooseZipEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9117',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_zip_filter',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'apply_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9119
export const emitAnalyticsResetFiltersEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9119',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'reset_filters',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'reset_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Saved Views ---

// https://dataportal.zillowgroup.net/event-registry/9120
export const emitAnalyticsCreateSavedViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9120',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'create_saved_view',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'manage_filter_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9121
export const emitAnalyticsClearSavedViewsEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9121',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'clear_saved_views',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'manage_filter_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9122
export const emitAnalyticsClickSavedViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9122',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_saved_view',
      trigger_location_nm: 'analytics',
    },
    semantic: {
      semantic_event_nm: 'manage_filter_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Report / Map View Switches ---

// https://dataportal.zillowgroup.net/event-registry/9123
export const emitOverviewSwitchToReportViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9123',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_report_view',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9124
export const emitOverviewSwitchToMapViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9124',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_view',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9125
export const emitMarketDataSwitchToReportViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9125',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_report_view',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9126
export const emitMarketDataSwitchToMapViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9126',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_view',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9127
export const emitAdSpendSwitchToReportViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9127',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_report_view',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9128
export const emitAdSpendSwitchToMapViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9128',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_view',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Export ---

// https://dataportal.zillowgroup.net/event-registry/9129
export const emitOverviewExportEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9129',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'export',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'export_analytics',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9130
export const emitOverviewExportPdfEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9130',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'pdf',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'switch_to_pdf',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9131
export const emitMarketDataExportEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9131',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'export',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'export_analytics',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9132
export const emitMarketDataExportPdfEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9132',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'pdf',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'switch_to_pdf',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9133
export const emitRenterDataExportEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9133',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'export',
      trigger_location_nm: 'analytics_renter_data',
    },
    semantic: {
      semantic_event_nm: 'export_analytics',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9134
export const emitRenterDataExportPdfEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9134',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'pdf',
      trigger_location_nm: 'analytics_renter_data',
    },
    semantic: {
      semantic_event_nm: 'switch_to_pdf',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9135
export const emitAdSpendExportEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9135',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'export',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'export_analytics',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9136
export const emitAdSpendExportPdfEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9136',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'pdf',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'switch_to_pdf',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Overview Interactions ---

// https://dataportal.zillowgroup.net/event-registry/9142
export const emitOverviewProspectsMarketAverageEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9142',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_prospects_market_average',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'show_market_averages',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9143
export const emitOverviewPageviewsMarketAverageEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9143',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_pageviews_market_average',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'show_market_averages',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9144
export const emitOverviewImpressionsMarketAverageEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9144',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_impressions_market_average',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'show_market_averages',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9145
export const emitOverviewPropertiesMarketTotalEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9145',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_properties_market_total',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'show_market_averages',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9146
export const emitOverviewListingQualityFieldEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9146',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_listing_quality_field',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'engage_listing_quality',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9147
export const emitOverviewListingQualityViewListingEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9147',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_listing_quality_view_listing',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'engage_listing_quality',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9148
export const emitOverviewMessageSalesProEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9148',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'message_sales_pro',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'message_sales_pro',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9149
export const emitOverviewMapClickPropertyEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9149',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_property',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9150
export const emitOverviewMapClickAreaEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9150',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_area',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Market Data Interactions ---

// https://dataportal.zillowgroup.net/event-registry/9151
export const emitMarketDataChooseBedFilterEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9151',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_bed_filter',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'manage_market_filter',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9152
export const emitMarketDataVacantMarketDataEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9152',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_vacant_market_data',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'show_market_averages',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9153
export const emitMarketDataMapClickAreaEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9153',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_area',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Ad Spend Interactions ---

// https://dataportal.zillowgroup.net/event-registry/9154
export const emitAdSpendTablePrintEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9154',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_print',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'interact_ad_spend_table',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9155
export const emitAdSpendTableDownloadEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9155',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_download',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'interact_ad_spend_table',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9156
export const emitAdSpendTableFullscreenEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9156',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_fullscreen',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'interact_ad_spend_table',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9157
export const emitAdSpendTablePreviewAdEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9157',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_preview_ad',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'interact_ad_spend_table',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9158
export const emitAdSpendTablePackageFilterEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9158',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_package_filter',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'interact_ad_spend_table',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9159
export const emitAdSpendMapClickAreaEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9159',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_area',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Industry Reports ---

// https://dataportal.zillowgroup.net/event-registry/9160
export const emitIndustryReportsChooseStateEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9160',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'choose_state_filter',
      trigger_location_nm: 'analytics_industry_reports',
    },
    semantic: {
      semantic_event_nm: 'interact_industry_reports',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9161
export const emitIndustryReportsMapViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9161',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_map_view',
      trigger_location_nm: 'analytics_industry_reports',
    },
    semantic: {
      semantic_event_nm: 'interact_industry_reports',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9162
export const emitIndustryReportsDownloadEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9162',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_to_download',
      trigger_location_nm: 'analytics_industry_reports',
    },
    semantic: {
      semantic_event_nm: 'interact_industry_reports',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// --- Pageviews ---

// https://dataportal.zillowgroup.net/event-registry/9163
export const emitPageviewAnalyticsOverviewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9163',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'analytics_overview',
      trigger_location_nm: 'analytics_overview',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9164
export const emitPageviewAnalyticsMarketDataEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9164',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'analytics_market_data',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9165
export const emitPageviewAnalyticsRenterDataEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9165',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'analytics_market_data',
      trigger_location_nm: 'analytics_market_data',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9166
export const emitPageviewAnalyticsAdSpendEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9166',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'analytics_ad_spend',
      trigger_location_nm: 'analytics_ad_spend',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9167
export const emitPageviewAnalyticsIndustryReportsEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9167',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'analytics_industry_reports',
      trigger_location_nm: 'analytics_industry_reports',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9805
export const emitPageviewAnalyticsMarketCompsEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9805',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'analytics_competitor_insights',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9806
export const emitMarketCompsSwitchToTableViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9806',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_table_view',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9807
export const emitMarketCompsSwitchToTrendsViewEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9807',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_trends_view',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'switch_analytics_view',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9808
export const emitMarketCompsMapSliderEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9808',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_map_slider',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9809
export const emitMarketCompsSelectCompetitorEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9809',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_select_competitor',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9810
export const emitMarketCompsUnselectCompetitorEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9810',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_unselect_competitor',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9811
export const emitMarketCompsSelectedCompetitorsOnlyEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9811',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_selected_competitors_only',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9812
export const emitMarketCompsHideNewConstructionEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '9812',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'click_hide_newcon',
      trigger_location_nm: 'analytics_competitor_insights',
    },
    semantic: {
      semantic_event_nm: 'interact_analytics_map',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });
